import { TechDimensions } from "../dimensions/TechDimensions";
import { GeoDimensions } from "../dimensions/GeoDimensions";
import { SessionDimensions } from "../dimensions//SessionDimensions";
import { UserDimensions } from "../dimensions/UserDimensions";
import { useEffect, useRef } from "react";
import { DEFAULT_VALUE } from "../types/LoggingTypes";
import { defaultOptions, getCookies, setCookie } from "../../helpers/commonFunctions";
import t from "../../locales/translation";
import { ActionDimensions } from "../dimensions/ActionDimensions";
import { updateScreenHistory } from "../helpers/updateScreenHistory";


const useLogging = (token: string, lang?:  string, loggingConfig? : {version?: string, loggingEnv?: {url: string, token: string}, sessionFunnelSource?: string, sessionFunnelPointOfEntry?: string})=>{
    const renderRef = useRef(0);
    ActionDimensions.getInstance().token = token ?? DEFAULT_VALUE;
    useEffect(()=>{
        if(loggingConfig && loggingConfig.sessionFunnelSource && loggingConfig.sessionFunnelSource.length > 0)
        {
            ActionDimensions.getInstance().sessionFunnelSource = loggingConfig.sessionFunnelSource;
            setCookie('session_funnel_source', loggingConfig.sessionFunnelSource, defaultOptions);
        }

        const urlParams = new URLSearchParams(window.location.search);
        const pos = urlParams.get("pos");
        if(pos)
        {
            ActionDimensions.getInstance().sessionFunnelPointOfEntry = pos;
            setCookie('sessionFunnelPointOfEntry', pos, defaultOptions);
        }
        else if(loggingConfig && loggingConfig.sessionFunnelPointOfEntry && loggingConfig.sessionFunnelSource.length > 0)
        {
            ActionDimensions.getInstance().sessionFunnelPointOfEntry = loggingConfig.sessionFunnelPointOfEntry;
            setCookie('sessionFunnelPointOfEntry', loggingConfig.sessionFunnelPointOfEntry, defaultOptions);
        }
        
        if(lang && loggingConfig && renderRef.current < 1)
        {
            updateScreenHistory('order_packages');
        }

        if(loggingConfig && loggingConfig.sessionFunnelSource && loggingConfig.sessionFunnelSource.length > 0 && loggingConfig.sessionFunnelSource != DEFAULT_VALUE)
        {   
            ActionDimensions.getInstance().sessionFunnelSource = loggingConfig.sessionFunnelSource;
            setCookie('session_funnel_source', loggingConfig.sessionFunnelSource, defaultOptions);
        }else {
            ActionDimensions.getInstance().sessionFunnelSource = ActionDimensions.getInstance().prevScreen;
        }
        
        ActionDimensions.getInstance().url = loggingConfig && loggingConfig.loggingEnv && loggingConfig.loggingEnv.url ? loggingConfig.loggingEnv.url : 'DEFAULT_VALUE';
        
        if(getCookies() && getCookies().ecountry !== undefined)
        {
            GeoDimensions.getInstance().geoAppCountry = getCookies().ecountry;
        }
        if(getCookies() && getCookies().userInfo && getCookies().userInfo.id)
        {   
            const userId = getCookies().userInfo.id.toString() ?? DEFAULT_VALUE;
            UserDimensions.getInstance().userMemberId = userId;
        }
        
        UserDimensions.getInstance().userTrackingId = (getCookies() && getCookies().device_uuid && getCookies().device_uuid.length > 0) ? getCookies().device_uuid : DEFAULT_VALUE;
        
        TechDimensions.getInstance().language = t.getLanguage() ?? DEFAULT_VALUE
        TechDimensions.getInstance().version = (loggingConfig && loggingConfig.version) ? loggingConfig.version : DEFAULT_VALUE;
        TechDimensions.getInstance().language = lang ?? DEFAULT_VALUE;
        
        SessionDimensions.getInstance().sessionId = getCookies().tgtTicket ? getCookies().tgtTicket : DEFAULT_VALUE;
        renderRef.current +=1;

        return ()=>{
            ActionDimensions.getInstance().sessionFunnelSource = DEFAULT_VALUE;
            ActionDimensions.getInstance().sessionFunnelPointOfEntry = DEFAULT_VALUE;
            if(renderRef && renderRef.current > 0)
            {
                setCookie('sessionFunnelPointOfEntry', loggingConfig.sessionFunnelPointOfEntry, {...defaultOptions, expires: '0'});
                setCookie('session_funnel_source', loggingConfig.sessionFunnelSource, {...defaultOptions, expires: '0'});
            }
        }

    }, [lang, loggingConfig])
    
}

export {useLogging}